import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { TeamsScreen } from "../../screens/settings/TeamsScreen.tsx";

/** `/settings/teams`: connect Microsoft Teams and choose where findings go. */
export const Route = createFileRoute("/_app/settings/teams")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("teams.getConnection", {})),
  component: TeamsScreen,
});
